import { Component, OnInit } from '@angular/core';

declare const $: any;
declare interface RouteInfo {
    path: string;
    title: string;
    icon: string;
    class: string;
}
export const ROUTES: RouteInfo[] = [
    { path: 'dashboard', title: 'Dashboard',  icon: 'dashboard', class: '' },
    { path: 'kursanci', title: 'Kursanci',  icon: 'person', class: '' },
    { path: 'kursant-new', title: 'Dodaj kursanta',  icon: 'person_add', class: '' },
    { path: 'grupy', title: 'Grupy',  icon: 'group', class: '' },
    { path: 'grupa-new', title: 'Dodaj grupę',  icon: 'group_add', class: '' },
];

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  menuItems: any[];

  constructor() { }

  ngOnInit() {
    this.menuItems = ROUTES.filter(menuItem => menuItem);
  }
  isMobileMenu() {
      if ($(window).width() > 991) {
          return false;
      }
      return true;
  };
}



// WEBPACK FOOTER //
// ./src/app/components/sidebar/sidebar.component.ts